import {
  Typography,
  Button,
  DialogContent,
  Box,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import { DatePicker, StaticDatePicker } from '@mui/x-date-pickers';
import { defaultColorPallete } from 'utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import useDateRangeDialogLogic from './useDataRangeDialogLogic';

type Props = {
  open: boolean;
  onClose: () => void;
  onApply: (startDate: string, endDate: string) => void;
};

export default function DateRangeDialog(props: Props) {
  const { open, onClose, onApply } = props;

  const {
    startDate,
    endDate,
    maxStartDate,
    maxEndDate,
    handleApply,
    handleReset,
    handleClose,
    handleStartDateChange,
    handleEndDateChange,
  } = useDateRangeDialogLogic(onClose, onApply);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '11px',
        },
      }}
    >
      <DialogTitle
        color="primary"
        bgcolor={defaultColorPallete.neutral.light}
        alignItems="center"
        display="flex"
        height="57px"
      >
        <IconButton onClick={handleClose} aria-label="close-daterangedialog">
          <ArrowBackIosIcon
            fontSize="small"
            sx={{ color: defaultColorPallete.primary.main }}
          />
        </IconButton>
        <Typography fontWeight="bold" variant="h6">
          Escolher data
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box
          display={{ xs: 'block', sm: 'flex' }}
          mt={1}
          border="1px solid #CCCCD6"
          p={4}
          gap={2}
          borderRadius="11px"
          alignItems="center"
        >
          <Box
            maxWidth={{ xs: '100%', sm: '50%' }}
            gap={2}
            alignItems="center"
            justifyContent="center"
          >
            <DatePicker
              value={startDate}
              disableOpenPicker
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
            />
            <StaticDatePicker
              disableHighlightToday
              displayStaticWrapperAs="desktop"
              value={startDate}
              minDate={maxStartDate}
              onChange={handleStartDateChange}
            />
          </Box>
          <Box
            gap={2}
            maxWidth={{ xs: '100%', sm: '50%' }}
            justifyContent="center"
          >
            <DatePicker
              disableHighlightToday
              disableFuture
              value={endDate}
              disableOpenPicker
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
            />
            <StaticDatePicker
              disableFuture
              disableHighlightToday
              displayStaticWrapperAs="desktop"
              value={endDate}
              maxDate={maxEndDate}
              onChange={handleEndDateChange}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
        <Button onClick={handleReset} variant="outlined">
          Redefinir
        </Button>
        <Button
          variant="contained"
          onClick={handleApply}
          disabled={!startDate || !endDate}
        >
          Aplicar filtro
        </Button>
      </DialogActions>
    </Dialog>
  );
}
